import { z } from 'zod'

import { LocalizedSchema } from './common'

export const MEDIA_ALLOWED_MIME = ['image/jpeg', 'image/png', 'image/webp', 'image/avif', 'image/svg+xml', 'application/pdf'] as const
export const MEDIA_MAX_BYTES = 15 * 1024 * 1024

export const MediaSchema = z.object({
  id: z.string(),
  url: z.string(),
  filename: z.string(),
  mimeType: z.string(),
  size: z.number().int(),
  width: z.number().int().nullable(),
  height: z.number().int().nullable(),
  alt: LocalizedSchema,
  createdAt: z.string(),
})
export type Media = z.infer<typeof MediaSchema>

export const UpdateMediaRequestSchema = z.object({ alt: LocalizedSchema })

/** Where a media file is referenced: any content document (image fields, blocks, rich-text HTML) or a site document. */
export const MEDIA_USAGE_KINDS = ['page', 'article', 'product', 'category', 'industry', 'swatch', 'custom', 'site'] as const
export const MediaUsageSchema = z.object({
  items: z.array(
    z.object({
      kind: z.enum(MEDIA_USAGE_KINDS),
      id: z.string(),
      title: z.string(),
      /** Admin route of the document that references the file. */
      editPath: z.string(),
    }),
  ),
})
export type MediaUsage = z.infer<typeof MediaUsageSchema>
